import { getSettingValueWithoutAssignment } from "@faire/deprecated-retailer-visitor-shared/settings/__internal__/getSetting";
import { FE_SKIP_HCAPTCHA_CALLS_FOR_TRUSTWORTHY_SESSIONS_241209 } from "@faire/web-settings/FE_SKIP_HCAPTCHA_CALLS_FOR_TRUSTWORTHY_SESSIONS_241209";

export const getSettingSkipHCaptchaCallsForTrustworthySessions = (): boolean =>
  getSettingValueWithoutAssignment(
    FE_SKIP_HCAPTCHA_CALLS_FOR_TRUSTWORTHY_SESSIONS_241209,
    false
  );
